import Vue          from 'vue'
import Vuex         from 'vuex'
import VuexORM      from '@vuex-orm/core'
import Secure       from '@/util/secure'
import Persisted    from 'vuex-persistedstate'

//import Notifications    from '@/apps/main/vuex/Notifications'
//import Settings         from '@/apps/main/vuex/Settings'
//import Kompetisi        from '@/apps/frc/models/vuex/Kompetisi'

Vue.use(Vuex)

let database = new VuexORM.Database();
//database.register(Notifications, {});
//database.register(Settings, {});
//database.register(Kompetisi, {});

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  plugins: [
    VuexORM.install(database),
    Persisted({
      storage: {
        getItem: key => Secure.dec(window.localStorage.getItem(key)),          
        setItem: (key, value) =>            
              window.localStorage.setItem(key, Secure.enc(value)),
        removeItem: key => window.localStorage.removeItem(key)
      }
    })
  ]
})
